// extracted by mini-css-extract-plugin
module.exports = {"contents":"Yk","sectionHeading":"Zk"};